<script setup lang="ts">
import {
  computed,
} from 'vue';

import type { IDashboardPersonalChiefForm } from '@modules/dashboard/types';
import type { FormSchema } from '@modules/forms/components/VForm/types';
import VLoader from '@components/loader/VLoader.vue';
import { TRANSLATION_GROUP_DASHBOARD_AFFILIATE } from '@modules/dashboard/constants';
import { useDashboardChiefQuery } from '@modules/dashboard/queries';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { EFormInputTypes } from '@modules/forms/enums';
import { useI18n } from '@modules/i18n/composables';

const { getTranslation } = useI18n();
const { data, isLoading } = useDashboardChiefQuery();

const formSchema = computed<FormSchema<IDashboardPersonalChiefForm>>(() => ({
  name: {
    type: EFormInputTypes.TEXT,
    label: getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_HEADER').value,
    value: data.value?.name,
  },
  ms_teams: {
    type: EFormInputTypes.TEXT,
    label: getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_MS_TEAMS').value,
    value: data.value?.ms_teams,
  },
  telegram: {
    type: EFormInputTypes.TEXT,
    label: getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_TELEGRAM').value,
    value: data.value?.telegram,
  },
  whatsapp: {
    type: EFormInputTypes.TEXT,
    label: getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_WHATSAPP').value,
    value: data.value?.whatsapp,
  },
  email: {
    type: EFormInputTypes.TEXT,
    label: getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_EMAIL').value,
    value: data.value?.email,
  },
}));
</script>

<template>
  <PCard v-data-qa-auto-id="'TheDashboardChief'">
    <template #title>
      {{ $getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'MANAGER_HEADER') }}
    </template>
    <template #content>
      <VLoader
        :loading="isLoading"
        mode="overlay"
      >
        <VForm
          :schema="formSchema"
          readonly
        />
      </VLoader>
    </template>
  </PCard>
</template>
